import { Protocol } from '../../types/sharedTypeImpl.ts';


interface Props {
    style?: React.CSSProperties;
    protocol: Protocol | undefined;
    activePositionIdx: number | null;
    setActivePositionIdx: (idx: number | null) => void;
}

export function ProtocolPositionsTable({
    style,
    protocol,
    activePositionIdx,
    setActivePositionIdx
}: Props) {

    return (
        <table style={style}>
            <thead>
                <tr>
                    <th>Position</th>
                    <th>Nominal</th>
                    <th>Upper Tol.</th>
                    <th>Lower Tol.</th>
                </tr>
            </thead>
            <tbody>
                {protocol?.positions.map((pos, index) => (
                    <tr
                        key={index}
                        className={activePositionIdx === index ? 'highlight--selected' : ''}
                        onClick={() => setActivePositionIdx(index)}
                    >
                        <td>{pos.positionNumber}</td>
                        {
                            pos.type === 'measurement'
                                ? <>
                                    <td>{pos.nominal}</td>
                                    <td>{pos.upperTolerance}</td>
                                    <td>{pos.lowerTolerance}</td>
                                </>
                                : <td colSpan={3}>{pos.description}</td>
                        }
                    </tr>
                ))}
            </tbody>
        </table>
    );
}